export const NOTIFICATIONS_NEW_NOTIFICATION = 'NOTIFICATIONS_NEW_NOTIFICATION';
export const NOTIFICATION_SETTINGS_FETCH = 'NOTIFICATION_SETTINGS_FETCH';
export const NOTIFICATION_SETTINGS_SAVE = 'NOTIFICATION_SETTINGS_SAVE';
